export default __webpack_public_path__ + "static/media/rh-ico-active.b647e945.svg";